import {
  BooleanField,
  ListButton,
  NumberField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { DateFieldWithStandardFormat } from "@/fields/DateFieldWithStandardFormat";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const ReceiptShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="transactionId" />
      <TextField source="originalTransactionId" />
      <TextField source="webOrderLineItemId" />
      <DateFieldWithStandardFormat source="originalPurchaseDate" />
      <TextField source="productId" />
      <NumberField source="quantity" />
      <DateFieldWithStandardFormat source="purchaseDate" />
      <DateFieldWithStandardFormat source="expiresDate" />
      <BooleanField source="isTrialPeriod" />
      <DateFieldWithStandardFormat source="cancellationDate" />
      <TextField source="cancellationReason" emptyText="-" />
      <TextField source="installId" />
      <DateFieldWithStandardFormat source="subscriptionCreatedAt" />
      <NumberField source="price" />
      <TextField source="clientAppId" />
      <TextField source="currency" />
      <DateFieldWithStandardFormat source="updatedAt" />
      <DateFieldWithStandardFormat source="createdAt" />
    </SimpleShowLayout>
  </Show>
);
